import { Route } from "react-router-dom";
import type { UnauthorizedPagePath } from "./UnauthorizedPagePaths";

export class UnauthorizedRoute extends Route<{}, UnauthorizedPagePath> {}